<template>
  <nav class="flex flex-col gap-1.5">
    <template v-for="item in items">
      <a
        v-if="item.url"
        :key="item.url"
        :href="item.url"
        :class="[
          itemClass.base,
          item.active && itemClass.active
        ]"
      >
        <icon v-if="item.icon" :name="item.icon" set="regular" :class="iconClass"/>
        {{ item.title || item.name }}
      </a>

      <button
        v-else
        :key="item.title"
        :class="[
          itemClass.base,
          item.active && itemClass.active
        ]"
      >
        <icon v-if="item.icon" :name="item.icon" set="regular" :class="iconClass"/>
        {{ item.title || item.name }}
      </button>
    </template>
  </nav>
</template>

<script setup>

import Icon from "@/components/Icon.vue"

defineProps({
  items: { type: Array, required: true },
})

const itemClass = {
  base: "py-2 px-4 rounded text-inherit flex items-center gap-3 hover:bg-gray-400/10 hover:text-inherit hover:no-underline",
  active: "bg-gray-400/10 font-medium text-blue dark:text-white",
}

const iconClass = "text-gray-400 dark:text-gray-600"

</script>
